import { Divider, Form, Input, Radio, Select } from "antd";
import { observer } from "mobx-react";
import { EIso3166OneAlpha2, EIso3166OneAlpha2EuCountries } from "@devowl-wp/iso-codes";
import { _i, __ } from "../../../../utils";
import { AFFILIATE_INVOICE_ADDRESS_CHANGE_FIELDS } from ".";
import { usePriorityCountries } from "../../../../hooks";
import { useStores } from "../../../../store";
const AccountAffiliateSignUpInvoiceAddressFields = observer(_ref => {
  let {
    setTradeRegisterExcerptFile
  } = _ref;
  const countries = usePriorityCountries("iso-3166-1-alpha-2");
  const {
    accountStore: {
      isAffiliate,
      session
    }
  } = useStores();
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Divider, {
    orientation: "left"
  }, __("Invoice address")), /*#__PURE__*/React.createElement(Form.Item, {
    name: ["affiliate", "invoiceAddress", "companyName"],
    label: __("Company name"),
    extra: __('If you do not have a registered company name (e.g. as a small business owner in Germany, "Kleinunternehmer"), enter your full name here.'),
    rules: [{
      required: true,
      message: __("Please enter a company name!")
    }],
    required: true
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    noStyle: true,
    shouldUpdate: () => true
  }, _ref2 => {
    let {
      setFieldsValue
    } = _ref2;
    return /*#__PURE__*/React.createElement(Form.Item, {
      name: ["affiliate", "invoiceAddress", "country"],
      label: __("Country"),
      extra: __("If you have more than one branch, specify the country of the branch to which the commissions should be paid. Depending on the country, the way of taxation will change."),
      required: true,
      rules: [{
        required: true,
        message: __("Please choose your country!")
      }]
    }, /*#__PURE__*/React.createElement(Select, {
      autoComplete: "dontshow" /* https://git.io/JTEn1 */,
      transitionName: null,
      placeholder: __("Choose your country..."),
      showSearch: true,
      notFoundContent: __("No data"),
      onChange: () => {
        // Reset file input to avoid issues as we can not write back to a new rendered input DOM element
        setFieldsValue({
          affiliate: {
            invoiceAddress: {
              tradeRegisterExcerpt: undefined
            }
          }
        });
        setTradeRegisterExcerptFile(undefined);
      },
      optionFilterProp: "children"
    }, /*#__PURE__*/React.createElement(Select.OptGroup, {
      label: __("EU")
    }, countries.eu.map(_ref3 => {
      let {
        key,
        label
      } = _ref3;
      return /*#__PURE__*/React.createElement(Select.Option, {
        value: key,
        key: key
      }, label);
    })), /*#__PURE__*/React.createElement(Select.OptGroup, {
      label: __("Rest of the world")
    }, countries.restOfTheWorld.map(_ref4 => {
      let {
        key,
        label
      } = _ref4;
      return /*#__PURE__*/React.createElement(Select.Option, {
        value: key,
        key: key
      }, label);
    }))));
  }), /*#__PURE__*/React.createElement(Form.Item, {
    name: ["affiliate", "invoiceAddress", "firstName"],
    label: __("First name"),
    required: true,
    rules: [{
      required: true,
      message: __("Please enter your first name!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    name: ["affiliate", "invoiceAddress", "lastName"],
    label: __("Last name"),
    required: true,
    rules: [{
      required: true,
      message: __("Please enter your last name!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    name: ["affiliate", "invoiceAddress", "street"],
    label: __("Street"),
    required: true,
    rules: [{
      required: true,
      message: __("Please enter your street!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    name: ["affiliate", "invoiceAddress", "zip"],
    label: __("Postcode"),
    required: true,
    rules: [{
      required: true,
      message: __("Please enter your postcode (ZIP code)!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    name: ["affiliate", "invoiceAddress", "city"],
    label: __("City / Town"),
    required: true,
    rules: [{
      required: true,
      message: __("Please enter your city/town!")
    }]
  }, /*#__PURE__*/React.createElement(Input, null)), /*#__PURE__*/React.createElement(Form.Item, {
    noStyle: true,
    shouldUpdate: (_ref5, _ref6) => {
      let {
        affiliate: {
          invoiceAddress: prevInv
        }
      } = _ref5;
      let {
        affiliate: {
          invoiceAddress: nextInv
        }
      } = _ref6;
      return (prevInv === null || prevInv === void 0 ? void 0 : prevInv.country) !== (nextInv === null || nextInv === void 0 ? void 0 : nextInv.country);
    }
  }, _ref7 => {
    let {
      getFieldValue,
      setFieldsValue
    } = _ref7;
    return (getFieldValue(["affiliate", "invoiceAddress", "country"]) === EIso3166OneAlpha2.Germany || getFieldValue(["affiliate", "invoiceAddress", "country"]) === EIso3166OneAlpha2.Austria) && /*#__PURE__*/React.createElement(Form.Item, {
      label: __("Small business"),
      name: ["affiliate", "invoiceAddress", "isSmallBusinessWithoutVatDeclaration"],
      extra: _i(getFieldValue(["affiliate", "invoiceAddress", "country"]) === EIso3166OneAlpha2.Austria ? __('Are you a small business owner ("Kleinunternehmer") and exempt from VAT according to {{a}}Section 6 (1)(27) UStG{{/a}}?') : __('Are you a small business owner ("Kleinunternehmer") and exempt from VAT according to {{a}}§ 19 UStG{{/a}}?'), {
        a: /*#__PURE__*/React.createElement("a", {
          href: getFieldValue(["affiliate", "invoiceAddress", "country"]) === EIso3166OneAlpha2.Austria ? __("https://www.usp.gv.at/en/steuern-finanzen/umsatzsteuer/kleinunternehmen.html") : __("https://dejure.org/gesetze/UStG/19.html"),
          rel: "noreferrer",
          target: "_blank"
        })
      }),
      rules: [{
        required: true,
        message: __("Please choose one option!")
      }]
    }, /*#__PURE__*/React.createElement(Radio.Group, {
      onChange: () => {
        // Reset file input to avoid issues as we can not write back to a new rendered input DOM element
        setFieldsValue({
          affiliate: {
            invoiceAddress: {
              tradeRegisterExcerpt: undefined
            }
          }
        });
        setTradeRegisterExcerptFile(undefined);
      }
    }, /*#__PURE__*/React.createElement(Radio.Button, {
      value: true
    }, __("Yes")), /*#__PURE__*/React.createElement(Radio.Button, {
      value: false
    }, __("No"))));
  }), /*#__PURE__*/React.createElement(Form.Item, {
    noStyle: true,
    shouldUpdate: (_ref8, _ref9) => {
      let {
        affiliate: {
          invoiceAddress: prevInv
        }
      } = _ref8;
      let {
        affiliate: {
          invoiceAddress: nextInv
        }
      } = _ref9;
      return (prevInv === null || prevInv === void 0 ? void 0 : prevInv.country) !== (nextInv === null || nextInv === void 0 ? void 0 : nextInv.country) || (prevInv === null || prevInv === void 0 ? void 0 : prevInv.isSmallBusinessWithoutVatDeclaration) !== (nextInv === null || nextInv === void 0 ? void 0 : nextInv.isSmallBusinessWithoutVatDeclaration);
    }
  }, _ref10 => {
    let {
      getFieldValue
    } = _ref10;
    const country = getFieldValue(["affiliate", "invoiceAddress", "country"]);
    if (country === undefined) {
      return null;
    }
    const isEuCountry = Object.values(EIso3166OneAlpha2EuCountries).indexOf(country) > -1;
    const isSwitzerland = country === EIso3166OneAlpha2.Switzerland;
    const isGermany = country === EIso3166OneAlpha2.Germany;
    const isAustria = country === EIso3166OneAlpha2.Austria;
    const isSmallBusinessWithoutVatDeclaration = isGermany || isAustria ? getFieldValue(["affiliate", "invoiceAddress", "isSmallBusinessWithoutVatDeclaration"]) : false;
    const isTradeRegisterExcerpt = !isEuCountry && !isSwitzerland || isGermany && isSmallBusinessWithoutVatDeclaration || isAustria && isSmallBusinessWithoutVatDeclaration;
    const isCompanyIdentificationNumberRequired = !isEuCountry;
    return /*#__PURE__*/React.createElement(React.Fragment, null, isEuCountry && isSmallBusinessWithoutVatDeclaration === false && /*#__PURE__*/React.createElement(Form.Item, {
      label: __("VAT ID"),
      name: ["affiliate", "invoiceAddress", "vatId"],
      rules: [{
        required: true,
        message: __("Please enter your VAT ID!")
      }]
    }, /*#__PURE__*/React.createElement(Input, null)), isCompanyIdentificationNumberRequired && /*#__PURE__*/React.createElement(Form.Item, {
      label: isSwitzerland ? "UID" : __("Company identification number"),
      name: ["affiliate", "invoiceAddress", "companyIdentificationNumber"],
      rules: [{
        required: true,
        message: isSwitzerland ? __("Please enter your UID!") : __("Please enter your company identification number!")
      }]
    }, /*#__PURE__*/React.createElement(Input, null)),
    // When submitting the form, the `companyIdentificationNumber` is used as `taxNumber`
    (!isSwitzerland && !isEuCountry || isEuCountry && isSmallBusinessWithoutVatDeclaration) && /*#__PURE__*/React.createElement(Form.Item, {
      label: __("Tax number"),
      name: ["affiliate", "invoiceAddress", "taxNumber"],
      extra: __("Your tax number must be included on receipts for payouts.") + (isCompanyIdentificationNumberRequired ? ` ${__('If there is only one registration number in your country also for tax purposes for your company, enter the same number as in "Company identification number" also in this field.')}` : ""),
      rules: [{
        required: true,
        message: __("Please enter your tax number!")
      }]
    }, /*#__PURE__*/React.createElement(Input, {
      placeholder: isGermany ? __("e.g. 123/456/78912") : undefined
    })), isTradeRegisterExcerpt && /*#__PURE__*/React.createElement(Form.Item, {
      noStyle: true,
      shouldUpdate: (_ref11, _ref12) => {
        let {
          affiliate: {
            invoiceAddress: prevInv
          }
        } = _ref11;
        let {
          affiliate: {
            invoiceAddress: nextInv
          }
        } = _ref12;
        return JSON.stringify(AFFILIATE_INVOICE_ADDRESS_CHANGE_FIELDS.map(k => nextInv[k])) !== JSON.stringify(AFFILIATE_INVOICE_ADDRESS_CHANGE_FIELDS.map(k => prevInv[k]));
      }
    }, _ref13 => {
      let {
        getFieldValue
      } = _ref13;
      const isTradeRegisterExcerptRequired = isAffiliate ? JSON.stringify(AFFILIATE_INVOICE_ADDRESS_CHANGE_FIELDS.map(k => getFieldValue(["affiliate", "invoiceAddress", k]))) !== JSON.stringify(AFFILIATE_INVOICE_ADDRESS_CHANGE_FIELDS.map(k => session.affiliate.affiliate.invoiceAddress[k])) : true;
      return /*#__PURE__*/React.createElement(Form.Item, {
        label: isGermany ? __("Trade license (Gewerbeschein; PDF)") : isAustria ? __("Trade license (Gewerbeberechtigung; PDF)") : __("Trade register excerpt (PDF)"),
        name: ["affiliate", "invoiceAddress", "tradeRegisterExcerpt"],
        required: isTradeRegisterExcerptRequired,
        rules: [{
          required: isTradeRegisterExcerptRequired,
          message: __("Please select the document as PDF file!")
        }]
      }, /*#__PURE__*/React.createElement(Input, {
        type: "file",
        accept: "application/pdf",
        onChange: e => {
          var _e$target$files;
          return setTradeRegisterExcerptFile((_e$target$files = e.target.files) === null || _e$target$files === void 0 ? void 0 : _e$target$files[0]);
        }
      }));
    }));
  }));
});
export { AccountAffiliateSignUpInvoiceAddressFields };